module.exports = __webpack_public_path__ + "static/media/1.b72eed86.jpg";